import React from 'react';
import { photos } from '../../data/mock';

export const PortfolioSection = ({ outdoorPhotos, indoorPhotos, studioPhotos, onCategoryClick }) => {
  // Get couples photos (we'll use some studio photos for now)
  const couplesPhotos = photos.filter(p => p.category === 'couples');
  
  return (
    <section id="portfolio" className="section-spacing bg-[#1a1a1a]">
      <div className="revolt-container">
        <div className="text-center mb-lg">
          <h2 className="section-title">Portfolio</h2>
          <p className="subtitle">Explore our photography collections</p>
        </div>
        
        <div className="portfolio-grid">
          <PortfolioCard 
            image={outdoorPhotos[0]?.image}
            title="Families"
            onClick={() => onCategoryClick('outdoor')}
            delay=""
          />
          <PortfolioCard 
            image={indoorPhotos[0]?.image}
            title="Newborns"
            onClick={() => onCategoryClick('indoor')}
            delay="stagger-1"
          />
          <PortfolioCard 
            image={studioPhotos[0]?.image}
            title="Maternity"
            onClick={() => onCategoryClick('studio')}
            delay="stagger-2"
          />
          <PortfolioCard 
            image={couplesPhotos[0]?.image || studioPhotos[1]?.image || outdoorPhotos[1]?.image}
            title="Couples"
            onClick={() => onCategoryClick('couples')}
            delay="stagger-3"
          />
        </div>
      </div>
    </section>
  );
};

const PortfolioCard = ({ image, title, onClick, delay }) => (
  <div 
    className={`portfolio-card fade-in-up ${delay}`}
    onClick={onClick}
  >
    <img src={image} alt={`${title} photography in Dubai by Elina K.`} loading="lazy" decoding="async" />
    <div className="portfolio-card-overlay">
      <span className="portfolio-card-subtitle">Explore Collection</span>
      <h3 className="portfolio-card-title">{title}</h3>
    </div>
  </div>
);
